import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "../Services/apiService";

const apiSlice = createSlice({
  name: "api",
  initialState: {
    data: null,
    status: "idle",
    error: null,
    idsStatus: [], // <-- add idsStatus here
  },
  reducers: {
    setIdsStatus(state, action) {
      state.data = action.payload;
    },
    clearIdsStatus(state) {
        state.data = null; // clear the array
      },
  },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchData.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(fetchData.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.data = action.payload;
//       })
//       .addCase(fetchData.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.error.message;
//       });
//   },
});

export const { setIdsStatus,clearIdsStatus } = apiSlice.actions; // <-- export the action
export default apiSlice.reducer;
